import { useTheme } from 'styled-components';

import { readableTextColor } from '../../lib/helpers/readableTextColor';

const validateHexCode = color => {
  const VALID_LENGTHS = [3, 6];

  if (!color || !VALID_LENGTHS.includes(color.length)) return false;

  return /[0-9A-F]+/i.test(color);
};

const parseColorHash = (color, fallbackColor) => {
  if (!color) return fallbackColor;

  const parsedColor = color.replace('#', '');

  return validateHexCode(parsedColor) ? `#${parsedColor}` : fallbackColor;
};

export const useBannerColor = ({ primaryColor }) => {
  const { colors } = useTheme();

  const boardColor = parseColorHash(primaryColor, colors.primary[100]);

  return { textColor: readableTextColor(boardColor), boardColor };
};
